//natives
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

//components
import Comunicados_lista from '../../../../../util/comunicados_contatos_lista/.mixins/';

export default class Contatos extends Component {
    render() {
        return (
            <>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Comunicados`}</title>
                </Helmet>
                <Comunicados_lista {...this.props}/>
            </>
        );
    }
}